import oRequest from '@/libsV2/request.js';

const URL = {
    DESIGN_DESIGNTAGS: 'archives/Design/designtags', //方案设计标签
    DESIGN_DETAIL:'archives/Design/designdetail',//变更记录
    DESIGN_ATTACHLIST: 'archives/Design/attachlist',//方案设计附件
    WORKORDER_DETAIL: 'archives/workorder/detail',//工单详情-定位交底
    DESIGN_APPROVAL: 'archives/Design/approvallog',//审批流
    ARCHIVES_LIST: 'archives/after/list',//售后维保
}
export default {
    designTags(data = {}) {
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.DESIGN_DESIGNTAGS, oData)
    },
    projectChange(data = {}) {
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.DESIGN_DETAIL, oData)
    },
    attachlist(data = {}) {
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.DESIGN_ATTACHLIST, oData)
    },
    orderDetail(data = {}) {
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.WORKORDER_DETAIL, oData)
    },
    DesginApproval(data = {}) {
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.DESIGN_APPROVAL, oData)
    },
    archivesList(data = {}) {
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.ARCHIVES_LIST, oData)
    },
    
}
